import { ICompany } from '../../redux/company/types';
import { IPaymentIntentResponse } from '../../redux/payment/types';
import { IAudition, IContest, IProject, UserSummary, IEvent } from './helper';
import { IActSummary, IProjectSummary } from './media.types';

export type Location = {
    type: string;
    coordinates: number[];
    address?: string;
    description?: string;
};

export type Status = 'published' | 'draft' | 'archived' | string;
export type IContestStatus = 'published' | 'draft';

export type Country = { name: string; flag: string; code: string; dial_code: string };

export type SelectionType = 'single' | 'multiple';

export interface IAutoSuggestionSearchCell {
    type: 'talent' | 'project' | 'contest' | 'audition' | 'event' | 'company';
    searchImage: string;
    title: string;
    id: string;
    isEvent?: boolean;
    contest_id?: string;
    preferred_name?: string;
    slug: string;
}

export interface DiscoverySearchModel {
    type: string;
    item: IAutoSuggestionSearchCell[];
    label: string;
}

export interface DiscoverySearchUnparsedResponse {
    acts: IActSummary[] | IProject[];
    projects: IProjectSummary[];
    contests: IContest[];
    users: UserSummary[];
    suggestion: IProject[] | IContest[] | UserSummary[];
    auditions: IAudition[];
    events: IEvent[];
    company: ICompany[];
}

export enum PLAYER_CONTROL {
    ON = 'on',
    OFF = 'off',
}

export type TPlayerControl = 'off' | 'on';

export type ActivityType =
    | 'commented on project'
    | 'commented on contest'
    | 'commented on act'
    | 'joined a contest'
    | 'voted for project'
    | 'joined thspian'
    | 'initiated a search'
    | 'viewed a project'
    | 'created a project'
    | 'created an act'
    | 'added team member'
    | 'liked a project'
    | 'liked a review'
    | 'liked a movie'
    | 'liked an act'
    | 'liked a comment'
    | 'liked a contest'
    | 'initiated a search'
    | 'liked a thougth'
    | 'created a thougth'
    | 'shared a thougth'
    | 'commented on a thougth'
    | 'voted for a submission'
    | 'created a contest'
    | 'won a contest';

export interface IPaymentCard {
    _id: string;
    created_at: string;
    user: string;
    authorization: Authorization;
    payment_method: string;
    payment_intent?: IPaymentIntentResponse;
    email_used: string;
    created_by: string;
    signature: string;
    __v: number;
}

export interface Authorization {
    id: string;
    object: string;
    address_city: string;
    address_country: string;
    address_line1: string;
    address_line1_check: string;
    address_line2: string;
    address_state: string;
    address_zip: string;
    address_zip_check: string;
    authorization_code: string;
    bin: string;
    last4: string;
    exp_month: string;
    exp_year: string;
    channel: string;
    card_type: string;
    bank: string;
    country_code: string;
    brand: 'master' | 'visa';
    reusable: boolean;
    signature: string;
    account_name: any;
    receiver_bank_account_number: any;
    receiver_bank: any;
    country: string;
    customer: string;
    cvc_check: string;
    dynamic_last4: string;
    fingerprint: string;
    funding: string;
    metadata: Record<string, string>;
    name: string;
    tokenization_method: string;
    wallet: string;
}

export type DisplayFilter = {
    displayValue: string;
    fieldKey: string;
};
